import React from 'react'
import PropTypes from 'prop-types'
import { Button as ChakraButton } from '@chakra-ui/core'

const Button = ({ children, variantColor, size, icon, ...props }) => (
	<ChakraButton
		variantColor={variantColor}
		size={size}
		{...props}
		leftIcon={icon}
		textTransform='uppercase'
		rounded='lg'
		fontWeight='normal'
	>
		{children}
	</ChakraButton>
)

Button.displayName = 'Button'

Button.defaultProps = {
	size: 'lg',
	variantColor: 'primary',
	icon: undefined
}

Button.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	variantColor: PropTypes.string,
	size: PropTypes.string,
	icon: PropTypes.string
}

export default Button
